<template>
    <div class="min-h-full flex items-center justify-center mt-12">
        <div class="container-padded w-3/5 space-y-8 shadow-md sm:p-12">
                <div class="flex grid grid-cols-2">
                    <div>
                        <h2 class="text-center mb-4">
                            Free Pro
                        </h2>
                    </div>
                    <div>
                        <h2 class="text-center mb-4">
                            Premium Pro
                        </h2>
                    </div>
                    <FreeProFeatures class="align-top" :user="this.user"/>
                    <ProFeatures class="align-top" :user="this.user"/>
                    <div class="text-center">
<!--                        <a class="text-xl text-salesium-blue" href="/">Free</a>-->
                       <form @submit.prevent="goFree" class="space-y-6">
                            <button type="submit" :disabled="disabled"
                                    class="primary-btn mt-14 px-12">
                                Free
                            </button>
                       </form>
                    </div>
                    <div class="text-center">
                        <form @submit.prevent="goPremium" class="space-y-6">
                            <button type="submit" :disabled="disabled"
                                    class="primary-btn mt-14 px-12">
                                Upgrade
                            </button>
                        </form>
                    </div>
                </div>
        </div>
    </div>
</template>

<script>
import ProFeatures from './ProFeatures.vue';
import FreeProFeatures from './FreeProFeatures.vue';
import Vue from "vue";

export default {
    data() {
        return {
            disabled: false,
        }
    },
    props:["user"],
    methods: {
        goFree() {
            this.disabled = true;
//            Vue.toasted.success('Successfully signed up as Free user!',
//                {
//                    duration: 5000, //milliseconds
//                    position: "top-left"
//                });
            window.location.href = '/';
        },
        goPremium() {
            this.disabled = true;
            window.location.href = '/api/user/checkout-premium';
        }
    },
    components: {
        FreeProFeatures,
        ProFeatures
    },
    name: "ProRegistrationChoice"
}
</script>

<style scoped>
.animation-in {
    transform-origin: left;
    animation: in 0.6s ease-in-out;
}
.animation-out {
    transform-origin: bottom left;
    animation: out 0.6s ease-in-out;
}
</style>
